(function(){
  if (window.__avcReady) return;
  window.__avcReady = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var state = { cart: null, open: false };
  var lockEls = [];

  function money(cents, cur){
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function sized(url, w){ if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  var FLAKE = '<svg viewBox="-50 -50 100 100" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><g id="avcf"><path d="M0-8V-46M0-31l-10-10M0-31l10-10M0-17l-7-7M0-17l7-7"/></g><use href="#avcf" transform="rotate(60)"/><use href="#avcf" transform="rotate(120)"/><use href="#avcf" transform="rotate(180)"/><use href="#avcf" transform="rotate(240)"/><use href="#avcf" transform="rotate(300)"/></svg>';

  var wrap = document.createElement('div');
  wrap.className = 'avc';
  wrap.innerHTML =
    '<div class="avc-overlay" data-avc-close></div>' +
    '<aside class="avc-drawer" role="dialog" aria-modal="true" aria-label="Your cart" tabindex="-1">' +
      '<div class="avc-head"><h2 class="avc-title">Your cart <small data-avc-count></small></h2>' +
      '<button type="button" class="avc-close" data-avc-close aria-label="Close cart"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M3 3l10 10M13 3L3 13"/></svg></button></div>' +
      '<div class="avc-body" data-avc-body></div>' +
      '<div class="avc-foot" data-avc-foot hidden>' +
        '<div class="avc-sub avc-save-row" data-avc-saverow hidden><span>You save</span><span class="avc-save-amt" data-avc-save></span></div>' +
        '<div class="avc-sub"><span>Subtotal</span><strong data-avc-subtotal></strong></div>' +
        '<p class="avc-note">Taxes and shipping calculated at checkout.</p>' +
        '<a class="avc-checkout" href="' + root + 'checkout" data-avc-checkout>Secure checkout <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg></a>' +
        '<button type="button" class="avc-continue" data-avc-close>Continue shopping</button>' +
      '</div>' +
    '</aside>' +
    '<style>.avc-save-row{font-size:14px;color:#f1dfb6;margin-bottom:6px}.avc-was{display:block;font-size:12.5px;color:rgba(226,232,244,.5);text-decoration:line-through;font-weight:400}.avc-disc{display:inline-block;margin-top:6px;font-size:11px;letter-spacing:.06em;color:#f1dfb6;background:rgba(241,223,182,.12);border:1px solid rgba(241,223,182,.25);border-radius:999px;padding:2px 9px}</style>';

  function mount(){ if (!wrap.parentNode) document.body.appendChild(wrap); }
  var $ = function(s){ return wrap.querySelector(s); };

  function lock(on){
    document.documentElement.classList.toggle('avc-lock', on);
    if (on){
      lockEls = [];
      var pw = document.querySelector('.page-wrapper');
      if (pw && /(auto|scroll)/.test(getComputedStyle(pw).overflowY)){ lockEls.push([pw, pw.style.overflowY]); pw.style.overflowY = 'hidden'; }
    } else {
      lockEls.forEach(function(p){ p[0].style.overflowY = p[1]; });
      lockEls = [];
    }
  }

  function open(){
    mount();
    if (state.open) return;
    state.open = true;
    document.documentElement.classList.add('avc-open');
    lock(true);
    setTimeout(function(){ var d = $('.avc-drawer'); if (d) d.focus({ preventScroll: true }); }, 50);
  }
  function close(){
    state.open = false;
    document.documentElement.classList.remove('avc-open');
    lock(false);
  }
  function openFresh(){
    open();
    if (state.cart) render(state.cart); else loading();
    getCart().then(render);
  }

  function loading(){ $('[data-avc-body]').innerHTML = '<div class="avc-loading"><i></i></div>'; }

  function bubble(count){
    document.querySelectorAll('.cart-bubble').forEach(function(b){ b.classList.toggle('visually-hidden', count === 0); });
    document.querySelectorAll('.cart-bubble__text-count').forEach(function(t){ t.textContent = count > 0 ? count : ''; t.classList.toggle('hidden', count === 0); });
  }

  function render(cart, opts){
    state.cart = cart;
    opts = opts || {};
    var body = $('[data-avc-body]'), foot = $('[data-avc-foot]');
    $('[data-avc-count]').textContent = cart.item_count ? cart.item_count + (cart.item_count === 1 ? ' item' : ' items') : '';
    bubble(cart.item_count);
    if (!cart.item_count){
      foot.hidden = true;
      body.innerHTML = '<div class="avc-empty">' + FLAKE + '<p>Your cart is empty</p><span>The snowman is waiting for you.</span></div>';
      return;
    }
    foot.hidden = false;
    $('[data-avc-subtotal]').textContent = money(cart.total_price, cart.currency);
    var saved = (cart.original_total_price || cart.total_price) - cart.total_price;
    $('[data-avc-saverow]').hidden = !(saved > 0);
    $('[data-avc-save]').textContent = saved > 0 ? '−' + money(saved, cart.currency) : '';
    var html = '';
    if (opts.added) html += '<div class="avc-toast-ok"><span style="width:18px;height:18px;display:inline-block">' + FLAKE + '</span>Added to your cart</div>';
    if (opts.error) html += '<div class="avc-error">' + esc(opts.error) + '</div>';
    cart.items.forEach(function(it){
      var variant = (it.options_with_values || []).filter(function(o){ return o.name !== 'Title'; }).map(function(o){ return esc(o.value); }).join(' · ');
      var was = it.original_line_price > it.final_line_price ? '<span class="avc-was">' + money(it.original_line_price, cart.currency) + '</span>' : '';
      var discs = (it.discounts || []).filter(function(d){ return d.title; }).map(function(d){ return '<span class="avc-disc">' + esc(d.title) + '</span>'; }).join(' ');
      html += '<div class="avc-item" data-key="' + esc(it.key) + '">' +
        '<a class="avc-img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(sized(it.image, 200)) + '" alt="' + esc(it.product_title) + '" width="84" height="84" loading="lazy">' : '') + '</a>' +
        '<div><a class="avc-name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + (variant ? '<div class="avc-variant">' + variant + '</div>' : '') + discs +
        '<div class="avc-qty"><button type="button" data-qty="-1" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-qty="1" aria-label="Increase quantity">+</button></div></div>' +
        '<div class="avc-right"><span class="avc-price">' + was + money(it.final_line_price, cart.currency) + '</span><button type="button" class="avc-remove" data-remove>Remove</button></div>' +
      '</div>';
    });
    body.innerHTML = html;
  }

  function getCart(){ return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function(r){ return r.json(); }); }

  function change(key, qty, row){
    if (row) row.classList.add('is-busy');
    return fetch(root + 'cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function(r){ return r.json().then(function(j){ return { ok: r.ok, j: j }; }); })
      .then(function(res){
        if (res.ok) render(res.j);
        else getCart().then(function(c){ render(c, { error: res.j.description || res.j.message || 'Could not update the quantity.' }); });
      })
      .catch(function(){ getCart().then(render); });
  }

  function add(form, btn){
    var fd = new FormData(form);
    if (!fd.get('quantity')) fd.set('quantity', '1');
    if (btn) btn.classList.add('is-loading');
    open();
    loading();
    return fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function(r){ return r.json().then(function(j){ return { ok: r.ok, j: j }; }); })
      .then(function(res){
        return getCart().then(function(c){ render(c, res.ok ? { added: true } : { error: res.j.description || res.j.message || 'Sorry, this item could not be added.' }); });
      })
      .catch(function(){ form.submit(); })
      .then(function(){ if (btn) btn.classList.remove('is-loading'); });
  }

  wrap.addEventListener('click', function(e){
    var c = e.target.closest('[data-avc-checkout]');
    if (c){ c.classList.add('is-busy'); return; }
    if (e.target.closest('[data-avc-close]')){ e.preventDefault(); close(); return; }
    var row = e.target.closest('.avc-item');
    if (!row || !state.cart) return;
    var key = row.getAttribute('data-key');
    var item = state.cart.items.filter(function(i){ return i.key === key; })[0];
    if (!item) return;
    var q = e.target.closest('[data-qty]');
    if (q){ change(key, Math.max(0, item.quantity + parseInt(q.getAttribute('data-qty'), 10)), row); return; }
    if (e.target.closest('[data-remove]')) change(key, 0, row);
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && state.open) close(); });

  /* Add to cart on the snowman page: no page reload */
  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form.matches || !form.matches('form.avs-form')) return;
    e.preventDefault();
    add(form, form.querySelector('[data-atc]'));
  }, true);

  /* The header cart icon (button or link) opens the snow drawer instead of the theme's */
  document.addEventListener('click', function(e){
    if (!e.target.closest || wrap.contains(e.target)) return;
    var trig = e.target.closest('[aria-controls="cart-drawer"], [data-testid="cart-drawer-trigger"]');
    if (trig){
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      openFresh();
      return;
    }
    var a = e.target.closest('a[href]');
    if (!a) return;
    var path;
    try { path = new URL(a.href, location.href).pathname; } catch (err) { return; }
    if (path !== root + 'cart' && path !== '/cart') return;
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault(); e.stopPropagation();
    openFresh();
  }, true);

  window.avcOpen = openFresh;
  window.avcRefresh = function(){ return getCart().then(render); };

  /* warm the cart so the drawer opens instantly */
  function warm(){ mount(); getCart().then(function(c){ render(c); }).catch(function(){}); }
  if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 2000 }); else setTimeout(warm, 800);
  window.addEventListener('pageshow', function(e){ if (e.persisted){ close(); getCart().then(render); } });
})();